module.exports = __webpack_public_path__ + "west_side_story.8d8a406f.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/west_side_story.jpg
// module id = vPB/
// module chunks = 0